import type { CSSProperties } from "react";
import { THEMES, useTheme, type ThemeId } from "../lib/theme";

/** Choose how the site looks. The choice is kept in this browser (see lib/theme.ts). */
export function Appearance() {
  const [theme, setTheme] = useTheme();
  return (
    <>
      <div className="page-head">
        <p className="label">Appearance</p>
        <h1 className="display">
          Pick a <em>look</em>.
        </h1>
        <p className="lede">
          Seven ways to dress the same desk. Everything works the same whichever you choose. It's remembered on this
          device only, so your phone and the office computer can differ.
        </p>
      </div>

      <fieldset className="theme-picker">
        <legend className="sr-only">Theme</legend>
        {THEMES.map((t) => (
          <label key={t.id} className={`theme-option${theme === t.id ? " chosen" : ""}`}>
            <input type="radio" name="theme" value={t.id} checked={theme === t.id} onChange={() => setTheme(t.id)} />
            <Preview id={t.id} swatches={t.swatches} />
            <span className="theme-name">
              {t.name}
              {theme === t.id && <span className="label"> · In use</span>}
            </span>
            <span className="theme-blurb">{t.blurb}</span>
          </label>
        ))}
      </fieldset>
    </>
  );
}

/** A thumbnail of the layout in the theme's own three colours: ground, type and accent. */
function Preview({ id, swatches: [ground, type, accent] }: { id: ThemeId; swatches: readonly [string, string, string] }) {
  const style = { "--g": ground, "--t": type, "--a": accent } as CSSProperties;
  return (
    <span className="theme-preview" data-preview={id} style={style} aria-hidden>
      <span className="pv-bar" />
      <span className="pv-body">
        <span className="pv-head" />
        <span className="pv-row" />
        <span className="pv-row" />
        <span className="pv-row" />
      </span>
    </span>
  );
}
